import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Search from "./components/Search";
import Library from "./components/Library";
import SongDescription from "./components/SongDescription";
import Lib_Podcast from "./components/Library/LibraryComponents/Lib_Podcast";
import Lib_Artist from "./components/Library/LibraryComponents/Lib_Artist";
import Lib_Albums from "./components/Library/LibraryComponents/Lib_Albums";
import MusicPlayer from "./components/MusicPlayer";
import { createStore } from "redux";
import { reducer } from "./reducer";
import { Provider } from "react-redux";
import PlayListDescription from "./components/PlaylistDescription";
import LeftLayout from "./components/LeftLayout";
import Home from "./components/Home";

const store = createStore(reducer);

ReactDOM.render(
  <React.StrictMode>
    {/* React Redux Storage */}
    <Provider store={store}>
      <Router>
        <LeftLayout />
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/album" element={<SongDescription />}>
            <Route path=":data_id" element={<SongDescription />} />
          </Route>
          <Route path="/shows" element={<SongDescription />}>
            <Route path=":data_id" element={<SongDescription />} />
          </Route>
          <Route path="/playlist" element={<PlayListDescription />}>
            <Route path=":data_id" element={<PlayListDescription />} />
          </Route>
          <Route path="/search" element={<Search />} />
          <Route path="/library/playlist" element={<Library />} />
          <Route path="/library/podcast" element={<Lib_Podcast />} />
          <Route path="/library/artist" element={<Lib_Artist />} />
          <Route path="/library/album" element={<Lib_Albums />} />
        </Routes>
        <MusicPlayer />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
